export const mockData = {
  services: [
    {
      id: 1,
      title: "Tours Formativos",
      description: "Tours de desarrollo profesional para agentes en formación con experiencias personalizadas e inmersivas que combinan visitas a clubes de élite, asistencia a partidos profesionales y exploración cultural, proporcionando una oportunidad única y enriquecedora para que los participantes aprendan, crezcan y amplíen su red de contactos en la industria del fútbol.",
      tag: "tours",
      link: "/servicios?tag=tours"
    },
    {
      id: 2,
      title: "Visitas a Clubes de Élite",
      description: "Acceso exclusivo a clubes profesionales de primer nivel en Europa. Visita instalaciones de entrenamiento, conoce directors deportivos, scouts y personal clave, comprende la estructura organizacional y operaciones diarias de clubes de élite. Una experiencia intensiva para entender el negocio desde dentro.",
      tag: "clubes",
      link: "/servicios?tag=clubes"
    },
    {
      id: 3,
      title: "Partidos y Entrenamientos",
      description: "Asiste a partidos profesionales y sesiones de entrenamiento de equipos de élite. Observa metodologías de trabajo, análisis táctico y dinámicas de equipo. Aprende cómo los agentes operan en estos entornos y construye conexiones valiosas con profesionales de la industria.",
      tag: "partidos",
      link: "/servicios?tag=partidos"
    },
    {
      id: 4,
      title: "Shadowing en Reuniones Reales",
      description: "Acompáñame en reuniones reales con directores deportivos, clubes, scouts y otros agentes. Experimenta de primera mano negociaciones, presentaciones de jugadores y construcción de relaciones profesionales. Aprende las habilidades prácticas que no se enseñan en ningún curso teórico.",
      tag: "shadowing",
      link: "/servicios?tag=shadowing"
    }
  ],
  destinations: [
    {
      id: 1,
      type: "Tour",
      country: "España",
      cities: "Madrid, Barcelona, Sevilla, Valencia, Bilbao",
      image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80",
      description: "Visita clubes top españoles"
    },
    {
      id: 2,
      type: "Tour",
      country: "Inglaterra",
      cities: "Londres, Manchester, Liverpool, Birmingham",
      image: "https://images.unsplash.com/photo-1624880357913-a8539238245b?w=800&q=80",
      description: "Premier League y Championship"
    },
    {
      id: 3,
      type: "Tour",
      country: "Italia",
      cities: "Roma, Turín, Milán, Florencia",
      image: "https://images.unsplash.com/photo-1459865264687-595d652de67e?w=800&q=80",
      description: "Serie A y clubes históricos"
    },
    {
      id: 4,
      type: "Tour",
      country: "Alemania",
      cities: "Berlín, Múnich, Dortmund, Hamburgo",
      image: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800&q=80",
      description: "Bundesliga y estructura alemana"
    },
    {
      id: 5,
      type: "Tour",
      country: "Francia",
      cities: "París, Lyon, Marsella, Niza",
      image: "https://images.unsplash.com/photo-1587329310686-91414b8e3cb7?w=800&q=80",
      description: "Ligue 1 y academias francesas"
    },
    {
      id: 6,
      type: "Tour",
      country: "Portugal",
      cities: "Lisboa, Oporto, Braga",
      image: "https://images.unsplash.com/photo-1553871434-9f0ae286e0fd?w=800&q=80",
      description: "Cantera y desarrollo portugués"
    },
    {
      id: 7,
      type: "Experiencia Intensiva",
      country: "España - Semana Intensiva",
      cities: "Madrid y Barcelona - 7 días",
      image: "https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?w=800&q=80",
      description: "Inmersión completa con reuniones reales"
    },
    {
      id: 8,
      type: "Experiencia Intensiva",
      country: "Inglaterra - Semana Premier",
      cities: "Londres y Manchester - 7 días",
      image: "https://images.unsplash.com/photo-1551958219-acbc608c6377?w=800&q=80",
      description: "Networking con agentes y clubes PL"
    },
    {
      id: 9,
      type: "Evento Especial",
      country: "Mundial Sub17 Doha 2026",
      cities: "Doha, Qatar - Noviembre 2026",
      image: "https://images.unsplash.com/photo-1579952363873-27f3bade9f55?w=800&q=80",
      description: "Experiencia única en el Mundial Sub17"
    },
    {
      id: 10,
      type: "Evento Especial",
      country: "Champions League Femenina",
      cities: "Semifinales - Ida y Vuelta",
      image: "https://images.unsplash.com/photo-1522778119026-d647f0596c20?w=800&q=80",
      description: "Asiste a ambos partidos de semifinal"
    }
  ],
  testimonials: [
    {
      id: 1,
      name: "Lukas Rojo",
      role: "Gestor Deportivo",
      text: "El tour a España con Agente 360 cambió mi perspectiva completamente. Asistir a reuniones reales con directores deportivos y ver cómo se negocian contratos en vivo fue invaluable. No hay forma de aprender esto en un curso online. Recomiendo 100% esta experiencia.",
      rating: 5
    },
    {
      id: 2,
      name: "Alexis Lescaud",
      role: "Gestor Deportivo",
      text: "Acompañar al mentor en visitas a clubes de la Premier League fue increíble. La atención al detalle, las conexiones reales y el aprendizaje práctico hacen de Agente 360 Tours la mejor inversión para cualquier agente.",
      rating: 5
    },
    {
      id: 3,
      name: "Emmanuela Lukac",
      role: "Agente FIFA",
      text: "Después del tour intensivo en Barcelona, conseguí mi primera conexión real con un club de LaLiga. El networking que haces en estos tours es imposible de replicar. Vale cada euro invertido.",
      rating: 5
    },
    {
      id: 4,
      name: "Gabriel Silva-Riesco",
      role: "Agente FIFA",
      text: "Asistir a Copa América con Edgar fue un constante aprendizaje, desde visitar clubes, negociaciones en vivo, visitas a talentos y entrevistas en medios.",
      rating: 5
    }
  ],
  stats: [
    {
      number: "50+",
      label: "Agentes Formados"
    },
    {
      number: "12",
      label: "Países Visitados"
    },
    {
      number: "10+",
      label: "Años de Experiencia"
    },
    {
      number: "30+",
      label: "Clubes Visitados"
    }
  ]
};
